import { render, staticRenderFns } from "./PassModal.vue?vue&type=template&id=474fbd3e&scoped=true"
import script from "./PassModal.vue?vue&type=script&lang=js"
export * from "./PassModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474fbd3e",
  null
  
)

export default component.exports